"use strict";
/**
 * Catapult REST API Reference
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.7.15
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
* The hash algorithm used to hash te proof: * 0 (Op_Sha3_256)  - The proof is hashed using sha3 256. * 1 (Op_Keccak_256)  - The proof is hashed using Keccak (ETH compatibility). * 2 (Op_Hash_160)  - The proof is hashed twice: first with Sha-256 and then with RIPEMD-160 (bitcoin’s OP_HASH160). * 3 (Op_Hash_256)  - The proof is hashed twice with Sha-256 (bitcoin’s OP_HASH256).
*/
var HashAlgorithmEnum;
(function (HashAlgorithmEnum) {
    HashAlgorithmEnum[HashAlgorithmEnum["NUMBER_0"] = 0] = "NUMBER_0";
    HashAlgorithmEnum[HashAlgorithmEnum["NUMBER_1"] = 1] = "NUMBER_1";
    HashAlgorithmEnum[HashAlgorithmEnum["NUMBER_2"] = 2] = "NUMBER_2";
    HashAlgorithmEnum[HashAlgorithmEnum["NUMBER_3"] = 3] = "NUMBER_3";
})(HashAlgorithmEnum = exports.HashAlgorithmEnum || (exports.HashAlgorithmEnum = {}));
//# sourceMappingURL=hashAlgorithmEnum.js.map